import React from "react";
import { useGetActiveStaffQuery } from "../../../features/employeeSlice";
import { usePaginationFromURL } from "../../../hooks/usePaginationFromURL";
import { ContactDirectory } from "./ContactDirectory";
import { PageShell } from "../staffStyles";

/**
 * Jagiir Contact — the company directory.
 *
 * Thin container: the page is a single read-only list, so the whole of it
 * lives in ContactDirectory.
 *
 * Pagination stays in the URL (usePaginationFromURL) so a page number survives
 * a refresh and can be shared. The hook is 1-indexed because that is what a URL
 * should read like; MUI's DataGrid is 0-indexed, so the two are converted here
 * rather than inside the table.
 */
export const MalkiyetContactFirst = () => {
  const {
    currentPage: urlPage,
    pageSize,
    setPage: setUrlPage,
    setPageSize,
  } = usePaginationFromURL({ defaultPage: 1, defaultPageSize: 50 });

  const page = urlPage - 1;
  const handlePageChange = (nextPage) => setUrlPage(nextPage >= 0 ? nextPage + 1 : 1);

  const { data: staff, isFetching } = useGetActiveStaffQuery();

  // The page container centres its children, so the width comes from here.
  return (
    <PageShell>
      <ContactDirectory
        staff={staff}
        isFetching={isFetching}
        page={page}
        onPageChange={handlePageChange}
        pageSize={pageSize}
        onPageSizeChange={(size) => {
          setPageSize(size);
          setUrlPage(1); // a new page size invalidates the current page number
        }}
      />
    </PageShell>
  );
};
